import { forwardRef } from "react"
import { cn } from "@/shared/lib/utils"
import { Button, type ButtonProps } from "@/shared/ui/button"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/shared/ui/tooltip"

/** Квадратная кнопка-иконка для панелей редактора; подпись: в aria-label, тултипе (десктоп) и title (фолбэк). */
export const ToolButton = forwardRef<HTMLButtonElement, ButtonProps & { label: string }>(
	function ToolButton({ label, className, children, ...props }, ref) {
		return (
			<Tooltip>
				<TooltipTrigger asChild>
					<Button
						ref={ref}
						type="button"
						variant="ghost"
						size="icon"
						aria-label={label}
						title={label}
						className={cn(
							"h-11 w-11 shrink-0 rounded-xl text-muted-foreground hover:text-foreground disabled:opacity-40 [&_svg]:size-[18px]",
							className,
						)}
						{...props}
					>
						{children}
					</Button>
				</TooltipTrigger>
				<TooltipContent>{label}</TooltipContent>
			</Tooltip>
		)
	},
)
